import { ReactNode } from 'react';

import MaterialContainer from '@mui/material/Container';
import classNames from 'classnames';

import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Box } from '@vk-hr-tek/ui/Box';

import { DegradationBanner } from '../../../layout/DegradationBanner';
import { useIsAuthDegradationBannerAllowed } from '../../hooks';

import { ContainerBackground } from './ContainerBackground';
import { useStyles } from './Container.styles';

export const Container = ({
  title,
  children,
  titleLogo,
  theme = 'general',
}: {
  title?: ReactNode;
  children: ReactNode | ReactNode[];
  theme?: 'general' | 'vk' | 'mobile' | 'ali' | 'oauth2';
  titleLogo?: ReactNode;
  className?: string;
}) => {
  const { classes } = useStyles();
  const isDesktop = useIsDesktop();
  const isDegradationBannerAllowed = useIsAuthDegradationBannerAllowed();

  return (
    <MaterialContainer className={isDesktop ? '' : classes.main_container}>
      {theme === 'vk' && <ContainerBackground />}
      <Box
        className={classNames(
          classes.container,
          theme === 'vk' && classes.container_theme_vk,
          theme === 'mobile' && classes.container_theme_mobile,
          theme === 'ali' && classes.container_theme_ali,
          theme === 'oauth2' && classes.container_theme_oauth2,
        )}
        pt={theme === 'ali' ? '40' : { xs: '0', md: '72' }}
        pb={theme === 'ali' ? '0' : '48'}
      >
        {title && (
          <Box pt={{ xs: '32', md: '0' }}>
            <Typography variant="h3">{title}</Typography>
          </Box>
        )}

        {titleLogo && (
          <Box
            pt={{ xs: '32', md: '0' }}
            mb="40"
            display="flex"
            justifyContent="center"
          >
            {titleLogo}
          </Box>
        )}
        <div className={classes.content}>
          {isDegradationBannerAllowed && (
            // С логотипом: вместе с его отступом даёт 52px до баннера, как в макете.
            // Без логотипа на мобильном у контейнера нет отступа сверху
            <DegradationBanner
              embedded
              mt={titleLogo ? '12' : { xs: '16', md: '0' }}
            />
          )}
          {children}
        </div>
      </Box>
    </MaterialContainer>
  );
};
